import React, { useState, useContext } from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import { Dialogue, Button } from '@crossroads/ui-components';
import { StripeContext, StripeButtonComponent, StripeCardComponent } from '@crossroads/stripe';
import { CheckboxField } from '../Field/index.js';
import cn from 'classnames';
import { CrossSvg } from '../../icons/index.js';
import styles from 'shop-views/PaymentMethods.scss';

/* eslint-disable react/boolean-prop-naming */
var stripeStyles = {
  style: {
    base: {
      color: styles.textColor,
      letterSpacing: "0.025em",
      fontSize: "16px",
      "::placeholder": {
        color: styles.colorMuted
      }
    },
    invalid: {
      color: "#9e2146"
    }
  }
};
var PaymentMethods = _ref => {
  var className = _ref.className,
      paymentMethodCode = _ref.paymentMethodCode,
      loading = _ref.loading,
      processing = _ref.processing,
      disabled = _ref.disabled,
      _ref$showHeader = _ref.showHeader,
      showHeader = _ref$showHeader === void 0 ? true : _ref$showHeader,
      terms = _ref.terms,
      paymentMethodsCards = _ref.paymentMethodsCards,
      agreement = _ref.agreement;
  var t = useTranslate();

  var _useState = useState(false),
      showTerms = _useState[0],
      setShowTerms = _useState[1];

  var _useContext = useContext(StripeContext),
      paymentMode = _useContext.paymentMode,
      setPaymentMode = _useContext.setPaymentMode,
      canMakeButtonPayment = _useContext.canMakeButtonPayment;

  var renderTerms = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modalWrapper
  }, /*#__PURE__*/React.createElement(Dialogue, {
    className: styles.modal,
    open: showTerms,
    setOpen: () => setShowTerms(false)
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.close_button,
    onClick: () => setShowTerms(false)
  }, /*#__PURE__*/React.createElement("img", {
    src: CrossSvg
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, agreement))), /*#__PURE__*/React.createElement("div", {
    className: styles.terms
  }, /*#__PURE__*/React.createElement(CheckboxField, {
    id: "terms",
    name: "terms",
    value: terms
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.text
  }, t("CHECKOUT.I_ACCEPT_THE"), " "), /*#__PURE__*/React.createElement("span", {
    className: cn(styles.link),
    onClick: e => {
      e.preventDefault();
      setShowTerms(true);
    }
  }, t("CHECKOUT.TERMS")))));

  if (paymentMethodCode === "free") {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.block
    }, showHeader && /*#__PURE__*/React.createElement("div", {
      className: styles.header
    }, /*#__PURE__*/React.createElement("h4", null, t("CHECKOUT.PAYMENT_TITLE"))), /*#__PURE__*/React.createElement("div", {
      className: styles.body
    }, renderTerms(), /*#__PURE__*/React.createElement("div", {
      className: styles.submitBlock
    }, /*#__PURE__*/React.createElement(Button, {
      className: styles.button,
      variant: "primary",
      loading: processing,
      disabled: disabled || !terms,
      type: "submit"
    }, t("CHECKOUT.CONFIRM_ORDER")))));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.block, className, {
      [styles.loading]: loading
    })
  }, showHeader && canMakeButtonPayment && /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("h4", null, paymentMode === "DEFAULT" ? t("CHECKOUT.PAYMENT_TITLE") : t(`CHECKOUT.${paymentMode}_PAYMENT`)), paymentMode === "CARD" && /*#__PURE__*/React.createElement(Button, {
    className: styles.editButton,
    variant: "blank",
    size: "small",
    onClick: () => setPaymentMode("DEFAULT")
  }, /*#__PURE__*/React.createElement("span", null, t("CHECKOUT.EDIT")))), /*#__PURE__*/React.createElement("div", null, renderTerms(), /*#__PURE__*/React.createElement("div", {
    className: styles.submitBlock
  }, paymentMode === "DEFAULT" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    disabled: disabled || !terms,
    loading: loading,
    className: styles.button,
    variant: "primary",
    onClick: () => setPaymentMode("CARD")
  }, t("PAYMENT.USE_CARD")), canMakeButtonPayment && /*#__PURE__*/React.createElement("div", {
    className: styles.orParagraph
  }, t("OR")), /*#__PURE__*/React.createElement(StripeButtonComponent, {
    Button: Button,
    disabled: disabled || !terms,
    processing: processing || loading,
    styles: styles,
    options: stripeStyles
  })), paymentMode === "CARD" && /*#__PURE__*/React.createElement(StripeCardComponent, {
    Button: Button,
    disabled: disabled || !terms,
    processing: processing || loading,
    styles: styles,
    options: stripeStyles
  })), paymentMethodsCards));
};

export { PaymentMethods };
//# sourceMappingURL=index.js.map
